__turbopack_context__.v({
  "app": "Tree-module__GbQivW__app",
  "container": "Tree-module__GbQivW__container",
  "draggingSource": "Tree-module__GbQivW__draggingSource",
  "dropTarget": "Tree-module__GbQivW__dropTarget",
  "listStyle": "Tree-module__GbQivW__listStyle",
  "placeholderContainer": "Tree-module__GbQivW__placeholderContainer",
  "treeRoot": "Tree-module__GbQivW__treeRoot",
});
